/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponseOfAbsenceRequestResponse } from '../api-models';
/**
 * AbsenceRequestsApi - axios parameter creator
 * @export
 */
export const AbsenceRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} absenceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsAbsenceRequestIdApprovePatch: async (absenceRequestId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceRequestId' is not null or undefined
            assertParamExists('absenceRequestsAbsenceRequestIdApprovePatch', 'absenceRequestId', absenceRequestId)
            const localVarPath = `/AbsenceRequests/{absenceRequestId}/Approve`
                .replace(`{${"absenceRequestId"}}`, encodeURIComponent(String(absenceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} absenceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsAbsenceRequestIdDenyPatch: async (absenceRequestId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceRequestId' is not null or undefined
            assertParamExists('absenceRequestsAbsenceRequestIdDenyPatch', 'absenceRequestId', absenceRequestId)
            const localVarPath = `/AbsenceRequests/{absenceRequestId}/Deny`
                .replace(`{${"absenceRequestId"}}`, encodeURIComponent(String(absenceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} absenceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsAbsenceRequestIdGet: async (absenceRequestId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceRequestId' is not null or undefined
            assertParamExists('absenceRequestsAbsenceRequestIdGet', 'absenceRequestId', absenceRequestId)
            const localVarPath = `/AbsenceRequests/{absenceRequestId}`
                .replace(`{${"absenceRequestId"}}`, encodeURIComponent(String(absenceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} absenceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsAbsenceRequestIdPendingPatch: async (absenceRequestId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceRequestId' is not null or undefined
            assertParamExists('absenceRequestsAbsenceRequestIdPendingPatch', 'absenceRequestId', absenceRequestId)
            const localVarPath = `/AbsenceRequests/{absenceRequestId}/Pending`
                .replace(`{${"absenceRequestId"}}`, encodeURIComponent(String(absenceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint queries the absence request service to find all employees   with pending call-off requests and returns their IDs as a list.
         * @summary Retrieves a list of employee IDs that have pending call-off (absence) requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsEmployeesPendingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/AbsenceRequests/employees/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbsenceRequestsApi - functional programming interface
 * @export
 */
export const AbsenceRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbsenceRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} absenceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absenceRequestsAbsenceRequestIdApprovePatch(absenceRequestId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfAbsenceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absenceRequestsAbsenceRequestIdApprovePatch(absenceRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} absenceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absenceRequestsAbsenceRequestIdDenyPatch(absenceRequestId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfAbsenceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absenceRequestsAbsenceRequestIdDenyPatch(absenceRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} absenceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absenceRequestsAbsenceRequestIdGet(absenceRequestId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfAbsenceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absenceRequestsAbsenceRequestIdGet(absenceRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} absenceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absenceRequestsAbsenceRequestIdPendingPatch(absenceRequestId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfAbsenceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absenceRequestsAbsenceRequestIdPendingPatch(absenceRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint queries the absence request service to find all employees   with pending call-off requests and returns their IDs as a list.
         * @summary Retrieves a list of employee IDs that have pending call-off (absence) requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absenceRequestsEmployeesPendingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absenceRequestsEmployeesPendingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbsenceRequestsApi - factory interface
 * @export
 */
export const AbsenceRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbsenceRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdApprovePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsAbsenceRequestIdApprovePatch(requestParameters: AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdApprovePatchRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfAbsenceRequestResponse> {
            return localVarFp.absenceRequestsAbsenceRequestIdApprovePatch(requestParameters.absenceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdDenyPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsAbsenceRequestIdDenyPatch(requestParameters: AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdDenyPatchRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfAbsenceRequestResponse> {
            return localVarFp.absenceRequestsAbsenceRequestIdDenyPatch(requestParameters.absenceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsAbsenceRequestIdGet(requestParameters: AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfAbsenceRequestResponse> {
            return localVarFp.absenceRequestsAbsenceRequestIdGet(requestParameters.absenceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdPendingPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsAbsenceRequestIdPendingPatch(requestParameters: AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdPendingPatchRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfAbsenceRequestResponse> {
            return localVarFp.absenceRequestsAbsenceRequestIdPendingPatch(requestParameters.absenceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint queries the absence request service to find all employees   with pending call-off requests and returns their IDs as a list.
         * @summary Retrieves a list of employee IDs that have pending call-off (absence) requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absenceRequestsEmployeesPendingGet(options?: AxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.absenceRequestsEmployeesPendingGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for absenceRequestsAbsenceRequestIdApprovePatch operation in AbsenceRequestsApi.
 * @export
 * @interface AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdApprovePatchRequest
 */
export interface AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdApprovePatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdApprovePatch
     */
    readonly absenceRequestId: number
}

/**
 * Request parameters for absenceRequestsAbsenceRequestIdDenyPatch operation in AbsenceRequestsApi.
 * @export
 * @interface AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdDenyPatchRequest
 */
export interface AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdDenyPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdDenyPatch
     */
    readonly absenceRequestId: number
}

/**
 * Request parameters for absenceRequestsAbsenceRequestIdGet operation in AbsenceRequestsApi.
 * @export
 * @interface AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdGetRequest
 */
export interface AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdGet
     */
    readonly absenceRequestId: number
}

/**
 * Request parameters for absenceRequestsAbsenceRequestIdPendingPatch operation in AbsenceRequestsApi.
 * @export
 * @interface AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdPendingPatchRequest
 */
export interface AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdPendingPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdPendingPatch
     */
    readonly absenceRequestId: number
}

/**
 * AbsenceRequestsApi - object-oriented interface
 * @export
 * @class AbsenceRequestsApi
 * @extends {BaseAPI}
 */
export class AbsenceRequestsApi extends BaseAPI {
    /**
     * 
     * @param {AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdApprovePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsenceRequestsApi
     */
    public absenceRequestsAbsenceRequestIdApprovePatch(requestParameters: AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdApprovePatchRequest, options?: AxiosRequestConfig) {
        return AbsenceRequestsApiFp(this.configuration).absenceRequestsAbsenceRequestIdApprovePatch(requestParameters.absenceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdDenyPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsenceRequestsApi
     */
    public absenceRequestsAbsenceRequestIdDenyPatch(requestParameters: AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdDenyPatchRequest, options?: AxiosRequestConfig) {
        return AbsenceRequestsApiFp(this.configuration).absenceRequestsAbsenceRequestIdDenyPatch(requestParameters.absenceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsenceRequestsApi
     */
    public absenceRequestsAbsenceRequestIdGet(requestParameters: AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdGetRequest, options?: AxiosRequestConfig) {
        return AbsenceRequestsApiFp(this.configuration).absenceRequestsAbsenceRequestIdGet(requestParameters.absenceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdPendingPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsenceRequestsApi
     */
    public absenceRequestsAbsenceRequestIdPendingPatch(requestParameters: AbsenceRequestsApiAbsenceRequestsAbsenceRequestIdPendingPatchRequest, options?: AxiosRequestConfig) {
        return AbsenceRequestsApiFp(this.configuration).absenceRequestsAbsenceRequestIdPendingPatch(requestParameters.absenceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint queries the absence request service to find all employees   with pending call-off requests and returns their IDs as a list.
     * @summary Retrieves a list of employee IDs that have pending call-off (absence) requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsenceRequestsApi
     */
    public absenceRequestsEmployeesPendingGet(options?: AxiosRequestConfig) {
        return AbsenceRequestsApiFp(this.configuration).absenceRequestsEmployeesPendingGet(options).then((request) => request(this.axios, this.basePath));
    }
}
